import React from 'react'
import ContactTemplate from '../../templates/Contact/ContactTemplate'

const Contact = () => {
  return (
     <ContactTemplate />
  )
}

export default Contact